import React from 'react';
import PropTypes from 'prop-types';
import Wrapper from '../../components/wrapper';
import {convertPipeToBrTag} from '../../utils';
import './styles.css';
import ImageLoader from '../../components/image-loader';

/**
 * PromoNavigationItem
 */
const PromoNavigationItem = ({
                               containerId,
                               containerClass,
                               src,
                               pcText,
                               mbText,
                               href,
                               targetBlank,
                             }) => {
  //
  const getPcText = () => {
    if (pcText && pcText !== '') {
      return pcText;
    } else {
      return '';
    }
  };
  const getMbText = () => {
    if (mbText && mbText !== '') {
      return mbText;
    } else {
      return getPcText();
    }
  };
  //
  return (
    <Wrapper
      containerId={containerId}
      containerClass={containerClass}
    >
      <article className="PromoNavigationItem">
        <a className="PromoNavigationItem__link"
           href={(href !== null) ? href: null}
           target={(targetBlank !== null && targetBlank === true) ? '_blank': null}
        >
          
          <div className="PromoNavigationItem__image">
            <ImageLoader
              width={'100%'}
              ratio={0.5}
              src={src}
              backgroundSize={'cover'}
            />
          </div>
  
          {/*<div className="PromoNavigationItem__image">*/}
            {/*<span style={{backgroundImage: 'url(' + src + ')'}}/>*/}
          {/*</div>*/}
          
          <h5 className="PromoNavigationItem__heading">
            <span className="PromoNavigationItem__heading-pc">
              <div dangerouslySetInnerHTML={{__html: convertPipeToBrTag(getPcText())}}/>
            </span>
            <span className="PromoNavigationItem__heading-mb">
              <div dangerouslySetInnerHTML={{__html: convertPipeToBrTag(getMbText())}}/>
            </span>
          </h5>
          <span className="PromoNavigationItem__border"/>
        </a>
      </article>
    </Wrapper>
  )
};
PromoNavigationItem.propTypes = {
  containerId: PropTypes.string,
  containerClass: PropTypes.string,
  src: PropTypes.string,
  pcText: PropTypes.string,
  mbText: PropTypes.string,
  href: PropTypes.string,
  targetBlank: PropTypes.bool,
};
PromoNavigationItem.defaultProps = {
  containerId: null,
  containerClass: null,
  src: null,
  pcText: null,
  mbText: null,
  href: null,
  targetBlank: null,
};
export default PromoNavigationItem;



// WEBPACK FOOTER //
// ./src/containers/promo-navigation-item/index.jsx